import Joi from 'joi-browser';
import { ADMIN_ROLE, ARTIST_ROLE, THEATER_ADMIN_ROLE, USER_ROLE } from '../../../../constants';

export default {
  name: Joi.string()
    .label('Nombre')
    .trim()
    .max(255)
    .required(),
  email: Joi.string()
    .label('Correo electrónico')
    .email()
    .insensitive()
    .required(),
  password: Joi.string()
    .label('Contraseña')
    .trim()
    .allow([null, ''])
    .optional(),
  biography: Joi.string()
    .label('Biografía')
    .required(),
  website: Joi.string()
    .label('Sitio Web')
    .uri({
      scheme: ['http', 'https'],
    })
    .required(),
  type: Joi.string()
    .label('Rol')
    .valid([ADMIN_ROLE, THEATER_ADMIN_ROLE, ARTIST_ROLE, USER_ROLE])
    .required(),
  theater: Joi.object()
    .keys({
      id: Joi.string().optional(),
      name: Joi.string().required(),
    }),
  images: Joi.array()
    .label('Imágenes'),
};



// WEBPACK FOOTER //
// ./src/containers/Admin/User/Form/validation.js